

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadJobNotifications
// GETUNREADJOBNOTIFICATIONS   

const GETUNREADJOBNOTIFICATIONS= createAsyncThunk(
  "getUnreadJobNotifications/getUnreadJobNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadJobNotificationsSlice = createSlice({
  name: "getUnreadJobNotificationsSlice",
  initialState: {
    getUnreadJobNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadJobNotifications: (state) => {
        state.getUnreadJobNotifications.loading = false
        state.getUnreadJobNotifications.error = false
        state.getUnreadJobNotifications.data = []
        state.getUnreadJobNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADJOBNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadJobNotifications = {
        ...state.getUnreadJobNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADJOBNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadJobNotifications = {
        ...state.getUnreadJobNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADJOBNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadJobNotifications = {
        ...state.getUnreadJobNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadJobNotificationsAction = {
    GETUNREADJOBNOTIFICATIONS,
};

export { getUnreadJobNotificationsAction };
export default getUnreadJobNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadJobNotifications} = getUnreadJobNotificationsSlice.actions